import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import BaseAvatar from "src/components/BaseAvatar"

const ActivityEntryAuthor = ({ author, icon }) => {
  if (author.kind === "system") {
    return (
      <BaseAvatar
        size="xs"
        backgroundColor="bg-gray-400"
        fallback={
          <i
            className={classNames(icon || "fa-solid fa-circle-info")}
            aria-hidden="true"
          />
        }
      />
    )
  }

  return (
    <BaseAvatar
      size="xs"
      src={author.avatarUrl || undefined}
      name={author.displayName}
      backgroundColor={author.backgroundColor}
    />
  )
}

ActivityEntryAuthor.propTypes = {
  author: PropTypes.shape({
    kind: PropTypes.oneOf(["system", "user"]).isRequired,
    displayName: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
    backgroundColor: PropTypes.string,
  }).isRequired,
  icon: PropTypes.string,
}

export default ActivityEntryAuthor
